import { type FC } from 'react'
import { twMerge } from 'tailwind-merge'
import { type SvgComponent, type DefaultProps } from '../../types'

export type SvgPasskeyAddedProps = DefaultProps &
  SvgComponent & {
    strokeColor?: string
  }

export const SvgPasskeyAdded: FC<SvgPasskeyAddedProps> = ({
  // Common default properties for each component
  id,
  testId,
  ariaLabel,
  width = 364,
  height = 246,
  className,
  strokeColor = '#2679B6',
}) => {
  // Final class names
  const finalClasses = twMerge(className)

  return (
    <svg
      {...(testId ? { 'data-testid': testId } : {})}
      {...(id ? { id } : {})}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 136 136"
      fill="none"
      className={finalClasses}
    >
      <path
        d="M81.5 128a64.615 64.615 0 01-16 2C29.878 130 1 101.122 1 65.5S29.878 1 65.5 1 130 29.878 130 65.5c0 5.523-.694 10.884-2 16"
        stroke={strokeColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M109 82a26.998 26.998 0 00-27 27 26.993 26.993 0 007.908 19.092A27.006 27.006 0 00109 136a26.991 26.991 0 0019.092-7.908 27.003 27.003 0 000-38.184A26.997 26.997 0 00109 82z"
        fill={strokeColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M123.783 96.316c.522.385.634 1.12.249 1.641l-16.435 22.305a1.17 1.17 0 01-.792.467 1.169 1.169 0 01-.886-.247l-11.74-9.391a1.174 1.174 0 011.467-1.834l10.786 8.629 15.71-21.321a1.173 1.173 0 011.641-.25z"
        fill="#fff"
      />
      <path
        d="M61.981 66c5.615 0 10.166-4.551 10.166-10.165 0-5.615-4.551-10.166-10.166-10.166-5.614 0-10.165 4.551-10.165 10.166C51.816 61.449 56.366 66 61.98 66zm27.109 0a7.907 7.907 0 10-11.295 7.117v12.085l3.388 3.389 5.648-5.648-3.389-3.388 3.389-3.389-2.801-2.801a7.907 7.907 0 005.06-7.364zm-7.907 0a2.259 2.259 0 110-4.517 2.259 2.259 0 010 4.518zm-10.301 4.564a13.555 13.555 0 00-5.512-1.175h-6.777a13.554 13.554 0 00-13.555 13.554v4.519h29.368V75.014a11.657 11.657 0 01-3.524-4.45z"
        fill={strokeColor}
      />
    </svg>
  )
}
